import type { Resultado } from './acesso';
import type { Sessao } from './auth';
import { escreverNaApi as escrever, lerDaApi as ler } from './giro';
import type { Escrita } from './giro';

/**
 * CONTROLADOS DO DIA (dono, 26/10/2026) — o front de /api/controlados. Os tipos espelham
 * @inovapay/database (controlados).
 */

export type TipoDoArmario = 'CONTROLADO' | 'ANTIBIOTICO' | 'DEFICIT' | 'MOLECULA';

export const ROTULO_DO_TIPO: Readonly<Record<TipoDoArmario, string>> = {
  CONTROLADO: 'Controlado',
  ANTIBIOTICO: 'Antibiótico',
  DEFICIT: 'Déficit de atenção',
  MOLECULA: 'Molécula controlada',
};

export interface VendaDoControlado {
  readonly instante: string;
  readonly cupom: string | null;
  readonly vendedor: string | null;
  readonly quantidade: number;
}

export interface ControladoVendido {
  readonly chave: string;
  readonly codigo: string | null;
  readonly descricao: string;
  readonly classificacao: string | null;
  readonly principioAtivo: string | null;
  readonly tipo: TipoDoArmario;
  readonly quantidade: number;
  readonly vendas: readonly VendaDoControlado[];
  readonly conferidoPor: string | null;
  readonly conferidoEm: string | null;
}

export interface ControladosDoDia {
  readonly hoje: string;
  readonly dia: string;
  readonly itens: readonly ControladoVendido[];
  readonly conferidos: number;
  readonly leitura: {
    readonly dia: string;
    readonly lidasAte: string | null;
    readonly completa: boolean;
    readonly aviso: string | null;
  };
}

export const lerControlados = (dia?: string | null): Promise<Resultado<ControladosDoDia>> =>
  ler<ControladosDoDia>(`/api/controlados${dia ? `?dia=${dia}` : ''}`);

export const marcarConferido = (
  s: Sessao,
  m: { dia: string; chave: string; conferido: boolean },
): Promise<Escrita<{ ok: boolean }>> => escrever(s, 'PUT', '/api/controlados/conferido', m);
